<template>
  <div class="prazo-do-dossie" :class="'prazo-do-dossie_' + situacao.estado">
    <div class="prazo-do-dossie__cabecalho">
      <span class="prazo-do-dossie__titulo">
        <i class="far fa-clock" aria-hidden="true"></i>
        Prazo do dossiê
        <span v-if="situacao.prorrogado" class="tags tags_cor-azul">
          Prorrogado
        </span>
      </span>

      <button
        v-if="situacao.rotuloBotaoProrrogar"
        type="button"
        class="botao botao_medio botao_contorno botao_com-icone-para-esquerda prazo-do-dossie__botao-prorrogar"
        :class="'prazo-do-dossie__botao-prorrogar_' + situacao.estado"
        @click="$emit('prorrogar')"
      >
        <i class="far fa-clock" aria-hidden="true"></i>
        {{ situacao.rotuloBotaoProrrogar }}
      </button>
    </div>

    <div class="prazo-do-dossie__status">
      <span class="prazo-do-dossie__contagem">
        {{
          situacao.vencido
            ? situacao.diasEmAtraso +
              (situacao.diasEmAtraso === 1
                ? " dia em atraso"
                : " dias em atraso")
            : situacao.diasRestantes +
              (situacao.diasRestantes === 1
                ? " dia restante"
                : " dias restantes")
        }}
      </span>
      <span class="prazo-do-dossie__detalhe">
        Dia {{ situacao.diaAtual }} de {{ situacao.totalDeDias }} ·
        {{ situacao.vencido ? "venceu em" : "vence em" }}
        {{ $tempo.formatarParaPadraoBrasileiro(situacao.dataDeVencimento) }}
      </span>
    </div>

    <div class="prazo-do-dossie__barra">
      <div
        class="prazo-do-dossie__barra-preenchida"
        :style="{ width: situacao.percentualConsumido + '%' }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "prazo-do-dossie",
  props: {
    situacao: {
      type: Object,
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// PrazoDoDossie.vue?0bfc1be8